/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, balance: NonNullable<unknown> }} Endpoint_Cost_FreeInputs */

const en_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your first ${i?.count} requests are free with the ${i?.balance} starting balance.`)
};

const zh_hans1_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`有了 ${i?.balance} 的初始余额，你的前 ${i?.count} 次请求免费。`)
};

const pt_br2_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suas primeiras ${i?.count} requisições são grátis com o saldo inicial de ${i?.balance}.`)
};

const es_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tus primeras ${i?.count} solicitudes son gratis con el saldo inicial de ${i?.balance}.`)
};

const fr_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vos ${i?.count} premières requêtes sont gratuites avec le solde de départ de ${i?.balance}.`)
};

const de_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine ersten ${i?.count} Anfragen sind mit dem Startguthaben von ${i?.balance} kostenlos.`)
};

const ru_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваши первые запросы (${i?.count}) бесплатны за счёт стартового баланса ${i?.balance}.`)
};

const it_endpoint_cost_free = /** @type {(inputs: Endpoint_Cost_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le tue prime ${i?.count} richieste sono gratuite con il saldo iniziale di ${i?.balance}.`)
};

/**
* | output |
* | --- |
* | "Your first {count} requests are free with the {balance} starting balance." |
*
* @param {Endpoint_Cost_FreeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_free = /** @type {((inputs: Endpoint_Cost_FreeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_FreeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_free(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_free(inputs)
	if (locale === "es") return es_endpoint_cost_free(inputs)
	if (locale === "fr") return fr_endpoint_cost_free(inputs)
	if (locale === "de") return de_endpoint_cost_free(inputs)
	if (locale === "ru") return ru_endpoint_cost_free(inputs)
	if (locale === "it") return it_endpoint_cost_free(inputs)
	return en_endpoint_cost_free(inputs)
});